"use client"
import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const ScrollToTopButton = () => {
  const [showButton, setShowButton] = useState(false);

  // Detect scroll position
  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 300) {
        setShowButton(true); // Show button after 300px scroll
      } else {
        setShowButton(false); // Hide button when less than 300px
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Scroll to top functionality
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    showButton ? (
      <Button
        onClick={scrollToTop}
        variant="contained"
        sx={{
          backgroundColor: 'black',
          '&:hover': {
            backgroundColor: '#333', // Slightly lighter black on hover
          },
          position: 'fixed',
          bottom: '40px',
          right: '20px',
          borderRadius: '50%',
          zIndex: 1000,
          width: 70,
          height: 70
        }}
      >
        <ArrowUpwardIcon />
      </Button>
    ) : null
  );
};

export default ScrollToTopButton;
